<div class="d-flex flex-row gap-2">
    @for (p of performance; track p) {
        @if (p.points === 3) {
            <div class="bar bar-3 bg-success"></div>
        }
        @if (p.points === 0) {
            <div class="bar bar-3 bg-danger"></div>
        }
        @if (p.points === 2) {
            <div class="d-flex flex-column">
                <div class="bar bg-danger bar-1"></div>
                <div class="bar bg-success bar-2"></div>
            </div>
        }
        @if (p.points === 1) {
            <div class="d-flex flex-column">
                <div class="bar bg-danger bar-2"></div>
                <div class="bar bg-success bar-1"></div>
            </div>
        }
    }
</div>
